import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface DownloadFiscalDocumentParams {
  invoiceId: string;
  fileType: 'danfe' | 'xml';
}

export function useDownloadFiscalDocument() {
  return useMutation({
    mutationFn: async ({ invoiceId, fileType }: DownloadFiscalDocumentParams) => {
      const { data, error } = await supabase.functions.invoke('download-fiscal-document', {
        body: { invoiceId, fileType }
      });

      if (error) throw error;
      
      if (!data?.success || !data?.url) {
        throw new Error('Erro ao gerar link de download');
      }

      // Abrir URL temporária em nova aba para download
      window.open(data.url, '_blank');

      return data;
    },
    onSuccess: (data, variables) => {
      toast.success('Download iniciado', {
        description: `Arquivo ${variables.fileType.toUpperCase()} disponível por ${data.expiresIn} segundos.`,
      });
    },
    onError: (error: any) => {
      toast.error('Erro no download', {
        description: error.message || 'Não foi possível baixar o documento.',
      });
    },
  });
}
